import { useState } from 'react';
import './App.css';

const CONTRACT = '0x89d1F8DAbA790feFE6a45aec0498e889f2F750B6';

/* Inline SVG filter for wobbly hand-drawn borders */
function RoughFilter() {
  return (
    <svg style={{ display: 'none' }} aria-hidden="true">
      <defs>
        <filter id="rough" x="-5%" y="-5%" width="110%" height="110%">
          <feTurbulence type="fractalNoise" baseFrequency="0.035" numOctaves="3" seed="7" result="noise" />
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="3.5"
            xChannelSelector="R" yChannelSelector="G" />
        </filter>
      </defs>
    </svg>
  );
}

function Nav() {
  return (
    <nav className="nav">
      <div className="nav-logo">$MIM ✨</div>
      <ul className="nav-links">
        <li><a href="#narrative">the story</a></li>
        <li><a href="#tokenomics">numbers</a></li>
        <li><a href="#buy">how 2 buy</a></li>
        <li><a href="#lore">lore</a></li>
      </ul>
    </nav>
  );
}

function Hero() {
  return (
    <section className="hero">
      {/* Left: title + CTA */}
      <div className="hero-left">
        <h1 className="hero-title">
          <span className="line-magic">MAGIC</span>
          <span className="line-internet">INTERNET</span>
          <span className="line-money">MONEY!!</span>
        </h1>

        <div className="hero-ticker" style={{ display: 'inline-block' }}>$MIM</div>

        <p className="hero-tagline">
          it wasnt launched.<br />
          it was <strong>left brewing</strong> in the cauldron for YEARS.<br />
          now it is awake. 🧙
        </p>

        <div className="hero-cta">
          <a href="#buy" className="btn btn-buy">🪄 BUY $MIM!!!</a>
          <a href="#narrative" className="btn btn-lore">📜 read lore</a>
        </div>
      </div>

      {/* Right: hand-drawn TV with video */}
      <div>
        <div className="hero-video-frame">
          <div className="hero-video-inner">
            <video src="/makepotionfinal.mp4" autoPlay muted loop playsInline />
          </div>
          <p className="hero-video-label">← making the magic potion 🧪</p>
        </div>
      </div>
    </section>
  );
}

function ContractBar() {
  const [copied, setCopied] = useState(false);
  function handleCopy() {
    navigator.clipboard.writeText(CONTRACT).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }
  return (
    <div className="contract-bar">
      <span className="contract-label">📋 contract address:</span>
      <span className="contract-address">{CONTRACT}</span>
      <button className="copy-btn" onClick={handleCopy}>
        {copied ? '✓ copied!!' : 'copy'}
      </button>
    </div>
  );
}

function TickerBar() {
  const items = ['$MIM', '✨ magic internet money ✨', 'brewed 4ever',
    '0% tax!!', 'community owned', 'the og spell'];
  const content = items.map((t, i) => (
    <span key={i}>{t}<span className="ticker-sep">•</span></span>
  ));
  return (
    <div className="ticker-bar" aria-hidden="true">
      <span className="ticker-inner">{content}{content}{content}</span>
    </div>
  );
}

function Narrative() {
  return (
    <section className="section-band band-yellow" id="narrative">
      {/* doodles */}
      <span className="doodle" style={{ top: 24, right: 60, transform: 'rotate(20deg)' }}>🌟</span>
      <span className="doodle" style={{ bottom: 32, right: 120, transform: 'rotate(-15deg)' }}>💫</span>

      <h2 className="section-heading" style={{ color: 'var(--orange)' }}>
        <span className="underline-squiggle" style={{ textDecorationColor: 'var(--orange)' }}>
          the story 📖
        </span>
      </h2>

      <div className="narrative-layout">
        <div>
          <div className="narrative-video-box">
            <video src="/pourintofermenter.mp4" autoPlay muted loop playsInline />
            <span className="vid-caption">pouring it into the fermenter!!</span>
          </div>
        </div>
        <div className="narrative-text">
          <p>
            a long time ago a wizard typed a spell in a terminal. he hit enter.
            nobody knew what he was doing. it was just <strong>magic internet money</strong> lol
          </p>
          <p>
            he poured it into the fermenter. sealed it up. and just... left it alone.
            <span className="pop"> for YEARS. uninterrupted.</span>
          </p>
          <p>
            then one day it was finally ready. it came to the surface. <strong>$MIM had been aging this whole time.</strong>
            not forgotten. just fermenting. the longer u wait the stronger it gets. 🧙‍♂️
          </p>
        </div>
      </div>
    </section>
  );
}

function Tokenomics() {
  const stats = [
    { num: '694.2T', label: 'total supply', color: 'var(--blue)'   },
    { num: '0%',   label: 'buy tax!!!',   color: 'var(--green)'  },
    { num: '0%',   label: 'sell tax!!',   color: 'var(--green)'  },
    { num: '🔒',   label: 'renounced',    color: 'var(--purple)' },
    { num: '100%', label: 'community',    color: 'var(--orange)' },
  ];
  return (
    <section className="section-band band-blue" id="tokenomics">
      <span className="doodle" style={{ top: 20, left: 80, transform: 'rotate(-10deg)' }}>📊</span>
      <h2 className="section-heading" style={{ color: 'var(--blue)' }}>
        <span className="underline-squiggle" style={{ textDecorationColor: 'var(--blue)' }}>
          numbers 🔢
        </span>
      </h2>
      <div className="token-grid">
        {stats.map((s) => (
          <div className="token-card" key={s.label}>
            <span className="token-num" style={{ color: s.color }}>{s.num}</span>
            <span className="token-label">{s.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

function HowToBuy() {
  const steps = [
    { num: '1',  title: 'get a wallet!!',    body: 'download metamask or whatever. just do it. go to ethereum.' },
    { num: '2',  title: 'get some ETH',      body: 'buy eth from coinbase or kraken. send it to ur wallet. easy.' },
    { num: '3',  title: 'go to uniswap',     body: 'go to uniswap. connect wallet. paste the $MIM address.' },
    { num: '4',  title: 'swap ETH → $MIM !!', body: 'set slippage to like 2%. click swap. u r in the cauldron now 🧙' },
  ];
  return (
    <section className="section-band band-green" id="buy">
      <span className="doodle" style={{ top: 28, right: 80, transform: 'rotate(10deg)' }}>🛒</span>
      <h2 className="section-heading" style={{ color: 'var(--green)' }}>
        <span className="underline-squiggle" style={{ textDecorationColor: 'var(--green)' }}>
          how 2 buy 💰
        </span>
      </h2>
      <div className="steps-list">
        {steps.map((s) => (
          <div className="step-card" key={s.num}>
            <div className="step-number">{s.num}.</div>
            <div className="step-content">
              <h3>{s.title}</h3>
              <p>{s.body}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function Lore() {
  const entries = [
    { year: '????',  desc: 'wizard types a spell. terminal blinks. something starts.' },
    { year: '2012',  desc: '"magic internet money" appears on the forums. joke? meme? PROPHECY.' },
    { year: '2018',  desc: 'everyone leaves. cauldron left alone. still bubbling tho.' },
    { year: '2021',  desc: 'almost ready. not yet. needs more time. more ferment.' },
    { year: '2023',  desc: 'something weird in the mempool. same pattern. over and over. 👀' },
    { year: '2025',  desc: '$MIM wakes up. not launched. ARRIVED. the brew is done!! 🧙🔥' },
  ];
  return (
    <section className="section-band band-pink" id="lore">
      <span className="doodle" style={{ top: 20, right: 100, transform: 'rotate(-12deg)' }}>📜</span>
      <h2 className="section-heading" style={{ color: 'var(--purple)' }}>
        <span className="underline-squiggle" style={{ textDecorationColor: 'var(--purple)' }}>
          the lore 🧙
        </span>
      </h2>
      <div className="lore-entries">
        {entries.map((e) => (
          <div className="lore-entry" key={e.year}>
            <div className="lore-year">{e.year}</div>
            <p className="lore-desc">{e.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

function Community() {
  return (
    <section className="section-band band-orange" id="community">
      <div className="community-inner">
        <h2 className="section-heading" style={{ color: 'var(--orange)' }}>
          <span className="underline-squiggle" style={{ textDecorationColor: 'var(--orange)' }}>
            join us!! 🤝
          </span>
        </h2>
        <p className="community-text">
          the spell doesnt work alone!!! every wizard counts.<br />
          join. spread the magic. hold the $MIM. 🧙✨
        </p>
        <div className="social-links">
          <a href="https://x.com/MagicMoneyERC20" target="_blank" rel="noreferrer" className="btn-social btn-twitter">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ display:'inline',verticalAlign:'middle',marginRight:8 }}>
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622Zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
            twitter/X
          </a>
          <a href="https://dexscreener.com/ethereum/" target="_blank" rel="noreferrer" className="btn-social btn-dex">📈 dexscreener</a>
        </div>
      </div>
    </section>
  );
}

function FermenterArt() {
  return (
    <section style={{ position: 'relative', borderTop: '3px solid var(--ink)', overflow: 'hidden', lineHeight: 0 }}>
      <img
        src="/fermenter.png"
        alt="the potion stored away aging"
        style={{ width: '100%', display: 'block', objectFit: 'cover' }}
      />
      <p style={{
        position: 'absolute',
        bottom: '20px',
        right: '28px',
        fontFamily: "'Permanent Marker', cursive",
        fontSize: 'clamp(1rem, 2.5vw, 1.6rem)',
        color: '#a3e635',
        textShadow: '0 2px 8px rgba(0,0,0,0.8)',
        lineHeight: 1.2,
        transform: 'rotate(1deg)',
      }}>
        still in there.<br />still aging. 🍶
      </p>
    </section>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-logo">$MIM ✨</div>
      <p className="footer-copy">magic internet money • brewed since the beginning • 🧙</p>
    </footer>
  );
}

export default function App() {
  return (
    <div className="app">
      <RoughFilter />
      <Nav />
      <Hero />
      <ContractBar />
      <TickerBar />
      <Narrative />
      <Tokenomics />
      <HowToBuy />
      <Lore />
      <Community />
      <FermenterArt />
      <Footer />
    </div>
  );
}
